import {
  register,
  init,
  getLocaleFromNavigator,
  locale as localeStore
} from "svelte-i18n";
import { SUPPORTED_LOCALES, isSupportedLocale } from "./languages.js";
import { getLanguageSnapshotSync, saveLanguageSetting } from "./languageStore.js";

export const DEFAULT_LOCALE = "de";

export function normalizeLocale(input) {
  if (!input) return null;
  const raw = String(input).trim();
  if (!raw) return null;

  // Normalize e.g. de-DE -> de
  const base = raw.split("-")[0].toLowerCase();
  if (isSupportedLocale(base)) return base;

  // A few aliases
  if (base === "nb" || base === "nn") return "no";

  return null;
}

// Lazy-load locale dictionaries.
register("de", () => import("./locales/de.json"));
register("en", () => import("./locales/en.json"));
register("es", () => import("./locales/es.json"));
register("hu", () => import("./locales/hu.json"));

// For all other supported locales, temporarily reuse en.json until translated.
for (const code of SUPPORTED_LOCALES) {
  if (code === "de" || code === "en" || code === "es" || code === "hu") continue;
  register(code, () => import("./locales/en.json"));
}

export function guessInitialLocale() {
  const stored = normalizeLocale(getLanguageSnapshotSync());
  if (stored) return stored;

  const nav = normalizeLocale(getLocaleFromNavigator());
  return nav || DEFAULT_LOCALE;
}

export function setAppLocale(nextLocale) {
  const normalized = normalizeLocale(nextLocale) || DEFAULT_LOCALE;
  localeStore.set(normalized);
  return normalized;
}

export async function initI18n({ initialLocale } = {}) {
  const selected = normalizeLocale(initialLocale) || guessInitialLocale();

  // Persist the chosen language to localStorage mirror so the login screen
  // and future startups are consistent (per-user persistence happens via Settings).
  try {
    await saveLanguageSetting(selected);
  } catch {
    // ignore
  }

  return init({
    fallbackLocale: "en",
    initialLocale: selected
  });
}
